import React from 'react';
import { InfoIcon, EditIcon, SaveIcon, CancelIcon } from '../../components/icons/Icons';

interface TaskInfoCardProps {
  code: string;
  name: string;
  taskPath: string;
  /** Reubicación de la tarea en el árbol (opcional). */
  destinations?: { id: string; label: string }[];
  movingLocation?: boolean;
  draftElementId?: string;
  onStartMoveLocation?: () => void;
  onSaveLocation?: () => void;
  onCancelMoveLocation?: () => void;
  onDraftElementIdChange?: (value: string) => void;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  taskOverdue: boolean;
  isProjectManager: boolean;
  editingDates: boolean;
  draftStartDate: string;
  draftEndDate: string;
  onStartEditDates: () => void;
  onSaveDates: () => void;
  onCancelEditDates: () => void;
  onDraftStartDateChange: (value: string) => void;
  onDraftEndDateChange: (value: string) => void;
}

export const TaskInfoCard: React.FC<TaskInfoCardProps> = ({
  code,
  name,
  taskPath,
  destinations,
  movingLocation = false,
  draftElementId = '',
  onStartMoveLocation,
  onSaveLocation,
  onCancelMoveLocation,
  onDraftElementIdChange,
  startDate,
  endDate,
  createdAt,
  updatedAt,
  taskOverdue,
  isProjectManager,
  editingDates,
  draftStartDate,
  draftEndDate,
  onStartEditDates,
  onSaveDates,
  onCancelEditDates,
  onDraftStartDateChange,
  onDraftEndDateChange,
}) => {
  return (
    <div className="detail-card">
      <h3 className="detail-card-title">
        <InfoIcon />
        Task Information
      </h3>
      <div className="detail-field">
        <span className="field-label">Code</span>
        <span className="field-value mono">{code}</span>
      </div>
      <div className="detail-field">
        <span className="field-label">Name</span>
        <span className="field-value">{name}</span>
      </div>
      <div className="detail-field">
        <span className="field-label">Location</span>
        {movingLocation ? (
          <span className="field-value location-move">
            <select
              value={draftElementId}
              onChange={e => onDraftElementIdChange?.(e.target.value)}
              autoFocus
            >
              {(destinations || []).map(d => (
                <option key={d.id} value={d.id}>{d.label}</option>
              ))}
            </select>
            <button type="button" className="comment-action-btn primary" onClick={onSaveLocation}>Save</button>
            <button type="button" className="comment-action-btn" onClick={onCancelMoveLocation}>Cancel</button>
          </span>
        ) : (
          <span className="field-value">
            {taskPath}
            {isProjectManager && onStartMoveLocation && (
              <button
                type="button"
                className="comment-action-btn"
                onClick={onStartMoveLocation}
                title="Move this task to another location"
              >
                Move
              </button>
            )}
          </span>
        )}
      </div>
      <div className="detail-field">
        <span className="field-label">
          Start Date
          {isProjectManager && !editingDates && (
            <button className="action-icon-btn edit" onClick={onStartEditDates} title="Edit dates"><EditIcon /></button>
          )}
          {isProjectManager && editingDates && (
            <span className="action-btn-group">
              <button className="action-icon-btn save" onClick={onSaveDates} title="Save"><SaveIcon /></button>
              <button className="action-icon-btn cancel" onClick={onCancelEditDates} title="Cancel"><CancelIcon /></button>
            </span>
          )}
        </span>
        {editingDates ? (
          <span className="field-value field-edit-row">
            <input type="date" className="inline-edit-input" value={draftStartDate} onChange={e => onDraftStartDateChange(e.target.value)} style={{ width: '140px' }} />
          </span>
        ) : (
          <span className="field-value">{startDate ? new Date(startDate + 'T00:00:00').toLocaleDateString() : 'Not set'}</span>
        )}
      </div>
      <div className="detail-field">
        <span className="field-label">End Date</span>
        {editingDates ? (
          <span className="field-value field-edit-row">
            <input type="date" className="inline-edit-input" value={draftEndDate} onChange={e => onDraftEndDateChange(e.target.value)} style={{ width: '140px' }} />
          </span>
        ) : (
          <span className={`field-value ${taskOverdue ? 'text-danger' : ''}`}>
            {endDate ? new Date(endDate + 'T00:00:00').toLocaleDateString() : 'Not set'}
            {taskOverdue && ' (Overdue)'}
          </span>
        )}
      </div>
      <div className="detail-field">
        <span className="field-label">Created</span>
        <span className="field-value">{new Date(createdAt).toLocaleDateString()}</span>
      </div>
      <div className="detail-field">
        <span className="field-label">Updated</span>
        <span className="field-value">{new Date(updatedAt).toLocaleString()}</span>
      </div>
    </div>
  );
};
